import { withInstall } from '@visual-design/utils'
// import Button from './src/button.vue'
import GradientButton from './src/gradient-button.vue'

// export const VButton = withInstall(Button)
export const VGradientButton = withInstall(GradientButton)

export default VGradientButton
